import { useEffect } from 'react';
import { useField } from 'formik';
import SearchIcon from '@material-ui/icons/Search';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import { usePrevious } from '@feedback/hooks';

type ExternalProps = {
  name: string;
  routeParams: Record<string, any>;
};

type Props = ExternalProps & TextFieldProps;

const SearchInput = (props: Props) => {
  const { routeParams, name } = props;

  const [field] = useField(name);

  const search = routeParams?.params?.search || '';

  const prevRouteParams = usePrevious(routeParams);

  useEffect(() => {
    if (!routeParams) {
      return;
    }

    const didURLChange =
      routeParams.path.includes('/busca/') &&
      (prevRouteParams && prevRouteParams.path) !== routeParams.path;

    if (didURLChange) {
      field.onChange(search);
    }
  }, [search]);

  return (
    <TextField
      variant="outlined"
      margin="normal"
      size="small"
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

export default SearchInput;
